module.exports = __webpack_public_path__ + "img/logo_thinksns+@2x.df39055c.png";